import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=4b16403b"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b16403b')) {
      api.createRecord('4b16403b', component.options)
    } else {
      api.reload('4b16403b', component.options)
    }
    module.hot.accept("./logo.vue?vue&type=template&id=4b16403b", function () {
      api.rerender('4b16403b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/logo.vue"
export default component.exports